import { render, staticRenderFns } from "./AcknowledgeDialog.vue?vue&type=template&id=556bbb1f&scoped=true"
import script from "./AcknowledgeDialog.vue?vue&type=script&lang=js"
export * from "./AcknowledgeDialog.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgeDialog.vue?vue&type=style&index=0&id=556bbb1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bbb1f",
  null
  
)

export default component.exports